import api from "../api";
import { GET_ERRORS, GET_MEMBERS, GET_STOPORDERS, GET_MEMBER, DELETE_MEMBER } from "./types";


export const createMember = (member, history) => async dispatch => {
  try {
    await api.post("/api/members", member);
    history.push("/member-list");
    dispatch({
      type: GET_ERRORS,
      payload: {}
    });
  } catch (err) {
    console.log(err.response)
    dispatch({
      type: GET_ERRORS,
      payload: err.response
    });
  }
};

export const nonAuthCreateMember = (member, history, myRef) => async dispatch => {
  try {
    await api.post("/api/members-new", member);
    myRef.current.show({ severity: "success", summary: 'Member added successfully', life: 6000 });
    dispatch({
      type: GET_ERRORS,
      payload: {}
    });
    setTimeout(() => {
      window.location.href = 'http://zcatwu.org.zw/';
    }, 1000)
  } catch (err) {
    myRef.current.show({ severity: "error", summary: `Oops, ${err.response.data.message}`, life: 6000 });
    dispatch({
      type: GET_ERRORS,
      payload: err.response
    });
  }
};

export const updateMember = (member, history) => async dispatch => {
  try {
    await api.put(`/api/members/${member.id}`, member);
    history.push("/member-list");
    dispatch({
      type: GET_ERRORS,
      payload: {}
    });
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response
    });
  }
};

export const getMembers = (size, page) => async dispatch => {
  const res = await api.get(`/api/members?size=${size}&page=${page}`);

  dispatch({
    type: GET_MEMBERS,
    payload: res.data

  });
  dispatch({
    type: GET_ERRORS,
    payload: {}
  });

};

export const getStoporders = (tuId) => async dispatch => {

  const res = await api.get(`/api/current-stoporders/${tuId}`);

  dispatch({
    type: GET_STOPORDERS,
    payload: res.data

  });
  dispatch({
    type: GET_ERRORS,
    payload: {}
  });

};
export const getMember = (id, history) => async dispatch => {
  try {
    const res = await api.get(`/api/members/${id}`);

    dispatch({
      type: GET_MEMBER,
      payload: res.data
    });
  } catch (error) {

    history.push("/home");
  }
};

export const deleteMember = id => async dispatch => {
  if (
    window.confirm(
      "Are you sure? This will delete the member and all the data related to it"
    )
  ) {
    await api.delete(`/api/members/${id}`);
    dispatch({
      type: DELETE_MEMBER,
      payload: id
    });
  }
};

export const getAllMembers = () => {

  api(`/api/members-list`, {
    method: 'GET',
    responseType: 'blob' //Force to receive data in a Blob Format
  })
    .then(response => {
      //Create a Blob from the PDF Stream
      const file = new Blob(
        [response.data],
        { type: 'application/pdf' });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //Open the URL on new Window

      window.open(fileURL);
    })
    .catch(error => {
      console.log(error);
    });
};

export const getYouths = () => {

  api(`/api/youths`, {
    method: 'GET',
    responseType: 'blob' //Force to receive data in a Blob Format
  })
    .then(response => {
      //Create a Blob from the PDF Stream
      const file = new Blob(
        [response.data],
        { type: 'application/pdf' });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //Open the URL on new Window

      window.open(fileURL);
    })
    .catch(error => {
      console.log(error);
    });
};